import React from 'react';

export default function TagIcon() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 7.5H7.01M7 3.5H12C12.5119 3.49999 13.0237 3.69525 13.4142 4.08579L20.4143 11.0858C21.1953 11.8668 21.1953 13.1332 20.4143 13.9142L13.4142 20.9142C12.6332 21.6953 11.3668 21.6953 10.5858 20.9142L3.58579 13.9142C3.19526 13.5237 3 13.0118 3 12.5V7.5C3 5.29086 4.79086 3.5 7 3.5Z" stroke="#382152" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
